import Cookies from 'js-cookie';
import { setFormAssemblyState } from 'js/utils/FormAssemblySubmit';
import cookieName from '../restrictedContentCookieName';

/**
 * Component for Login Modal.
 */
export default class LoginForm {
  /**
   * Start the component.
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);
    this.handleFormState = this.handleFormState.bind(this);

    if ('true' !== Cookies.get(cookieName)) {
      this.init();
    }
  }

  /**
   * Handle form submission state.
   *
   * @param {Event} event The event object.
   */
  handleFormState(event) {
    const { detail = {} } = event;
    const { status = '' } = detail;

    setFormAssemblyState(this.element, detail);

    if ('success' === status) {
      Cookies.set(cookieName, true, { expires: 30 });

      // Redirect to the homepage.
      const { origin } = window.location;
      window.location.href = origin;
    }
  }

  /**
   * Initialize the FormAssemblySubmit instance.
   */
  init() {
    this.element.addEventListener('sn.formstatechange', this.handleFormState);
  }
}
